import React from "react";
import CompleteTodo from "../components/CompleteTodo/CompleteTodo";
import Navbar from "../components/Navbar";
import Todo from "../components/Todo/Todo";

const Home = () => {
  return (
    <div className="grid place-items-center bg-blue-100 min-h-screen px-6 font-sans py-20">
      <Navbar />
      <Todo />
      <CompleteTodo />
    </div>
  );
};

export default Home;
